//
//                       _oo0oo_
//                      o8888888o
//                      88" . "88
//                      (| -_- |)
//                      0\  =  /0
//                    ___/`---'\___
//                  .' \\|     |// '.
//                 / \\|||  :  |||// \
//                / _||||| -:- |||||- \
//               |   | \\\  -  /// |   |
//               | \_|  ''\---/''  |_/ |
//               \  .-\__  '-'  ___/-. /
//             ___'. .'  /--.--\  `. .'___
//          ."" '<  `.___\_<|>_/___.' >' "".
//         | | :  `- \`.;`\ _ /`;.`/ - ` : | |
//         \  \ `_.   \_ __\ /__ _/   .-` /  /
//     =====`-.____`.___ \_____/___.-`___.-'=====
//                       `=---='
//
//
//     ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
//
//               佛祖保佑         永无BUG

/**
 * **********************
 * 整理query
 * **********************
 */
const formatQuery = (filter) => {
    let query = {}
    for (let [key, value] of Object.entries(filter)) {
        if (value) {
            query[key] = value
        }
    }
    query.timestamp = new Date().getTime()
    return query
}

// 对字符串编码
const urlEncode = (str) => {
    str = (str + '').toString();

    return encodeURIComponent(str).replace(/!/g, '%21').replace(/'/g, '%27').replace(/\(/g, '%28').
        replace(/\)/g, '%29').replace(/\*/g, '%2A').replace(/%20/g, '+');
}

/*********************************
 函数名：checkEmail
 功能：检查输入的字符串是否是邮箱
 参数：str —— 要检测的字符串
 返回值：是就返回true，否则返回false
 作者：李伟
 时间：2010-8-3
 **********************************/
const checkEmail = (str) => {
    var re = /^([a-zA-Z0-9_.-])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    if (re.test(str)) {
        return 1;
    } else {
        return 0;
    }
}

export {
    formatQuery,
    urlEncode,
    checkEmail
}